<!--我的页面-->
<template>
	<div class="id">
		<div class="navBar" @click="$router.back()">
			<van-icon name="arrow-left" />
			{{ $t('重置密码') }}
		</div>
		
		<div class="tabs dis-fle txt-16">
			<span class="item" :class="form.type == 1 ? 'active': ''" @click="changeTabs(1)">{{$t('登录密码')}}</span>
			<span class="item" :class="form.type == 2 ? 'active': ''" @click="changeTabs(2)">{{$t('资金密码')}}</span>
		</div>

		<div class="title">{{ $t('密码') }}</div>
		<div class="universal">
			<van-field v-model="form.password" :placeholder="$t('请输入密码')" :border="false" />
		</div>

		<div class="title">{{ $t('确认密码') }}</div>
		<div class="universal">
			<van-field v-model="form.passwordS" :placeholder="$t('请输入充值金额')" :border="false" />
		</div>

		<van-button class="btn" type="primary" @click="resetPwd">{{ $t('请再次输入密码') }}</van-button>
	</div>
</template>
<script>
	import {
		post
	} from '@/http/request'

	class FormData {
		constructor() {
			this.account = "";
			this.password = "";
			this.passwordS = "";
			this.code = "000000";
			this.type = "1";
		}
	}

	export default {
		components: {},
		data() {
			return {
				form: new FormData()
			};
		},
		created(){
			var type = this.$route.query?.type
			if (type) {
				this.form.type = type
			}
		},
		methods: {
			changeTabs(val) {
				if (val == this.form.type) return
				this.form = new FormData()
				this.form.type = val
			},
			resetPwd() {
				if (this.form.passwordS != this.form.password) {
					this.$notify.error(this.$t('两次密码不一致'));
					return
				}
				post(this.$apis.resetPwd, this.form).then(res => {
					if (res.code != 1) return
					this.$notify.success(res.msg)
					setTimeout(() => {
						this.$nav.back()
					}, 800)
				})
			}
		},
	};
</script>
<style lang="less" scoped>
	::v-deep .van-cell {
		padding: 0;
	}

	.id {
		color: #fff;
		padding: 0 15px;
		padding-bottom: 20px;
		padding-top: 50px;
		font-size: 14px;

		.navBar {
			background-color: #090d13;
			padding: 15px 10px;
			font-size: 18px;
			font-weight: 700;
			border-radius: 4px;
		}

		.title {
			padding-top: 20px;
			font-size: 16px;
			font-weight: 700;
		}

		.universal {
			padding: 10px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			border: 1px solid #3a3f47;
			margin-top: 10px;
			border-radius: 5px;

			.address {
				width: 85%;
				word-break: break-all;
			}
		}

		.btn {
			width: 100%;
			margin: 20px 0;
			background-color: #07ecfe;
			border-radius: 5px;
			color: #000;
		}
		
		.tabs {
			margin-top: 50px;
		
			.item {
				font-weight: 400;
				padding: 13px 24px;
				margin-right: 24px;
				border-radius: 8px;
				cursor: pointer;
		
				&.active {
					color: #fff;
					background-color: #00f0ff;
				}
			}
		}
		


	}
</style>